import { TherapistAction } from '../../../src/redux/actions/constant';

export const editTaskTimeAction = (payload: any) => {
    return {
        type: TherapistAction.EDIT_TASK_REQUEST,
        payload,
    };
};

export const resetEditTaskTimeAction = () => {
    return {
        type: TherapistAction.EDIT_TASK_RESET,
    };
};